import React from 'react'
import { Navigate } from 'react-router-dom'
import routes from 'routes'
import { useAuth } from 'contexts/AuthContext'

const DynamicRedirect = () => {
    const { user, loading } = useAuth()
    const token = localStorage.getItem('token')

    if (loading) return

    if (user?.is_employee !== undefined && user?.is_employee) {
        const accessibleRoute = routes.find(route => {
            return route.employeePermission && user.permissions.some(permission => permission.slug === route.employeePermission)
        })

        if (accessibleRoute) {
            return <Navigate to={`${accessibleRoute.layout}${accessibleRoute.path}`} replace />
        }
    }

    if (user?.is_employee !== undefined && !user?.is_employee) {
        return <Navigate to="/admin/default" replace />
    }

    if (!token) return <Navigate to="/auth/sign-in" replace />
}

export default DynamicRedirect
